// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Xfr1","productName":"Table_productName__32F1E"};